/*
 * Copyright (c) 2022 Eclipse Services a division of Quadrivium, Inc.
 * All rights reserved.
 */
(function () {
	if (!window.AuthorizeNetPopup) window.AuthorizeNetPopup = {};
	if (!AuthorizeNetPopup.options) AuthorizeNetPopup.options = {
		onPopupClosed: null,
		onResponse: null
	};

	AuthorizeNetPopup.closePopup = function () {
		if (AuthorizeNetPopup.options.onPopupClosed)
			AuthorizeNetPopup.options.onPopupClosed();
	};

	AuthorizeNetPopup.openPopup = function () {
		var popup = document.getElementById("divPaymentPopup");
		var popupScreen = document.getElementById("divPaymentPopupScreen");
		var ifrm = document.getElementById("iframePayment");
		ifrm.style.width = "100%";
		ifrm.style.height = "578px";

		popupScreen.style.display = "";
		popup.style.display = "";
		centerPopup();
		return true;
		};

	AuthorizeNetPopup.onReceiveCommunication = function (querystr) {
		var params = parseQueryString(querystr);
		switch (params["action"]) {
			case "successfulSave":
				AuthorizeNetPopup.closePopup();
				break;
			case "cancel":
				AuthorizeNetPopup.closePopup();
				break;
			case "return":
				let result = params["RESULT"];
				let ppResp = "{\"responseCode\":\""+params["RESULT"] + "\"";
				if (result !== null && result === "0") {
					ppResp = ppResp + ",\"refId\":\""+params["SECURETOKENID"]+"\"}";
				} else {
					ppResp = ppResp + "}";
				}
				if (AuthorizeNetPopup.options.onResponse)
					AuthorizeNetPopup.options.onResponse(ppResp);
				break;
			case "transactResponse":
				var response = params["response"];
				if (AuthorizeNetPopup.options.onResponse)
					AuthorizeNetPopup.options.onResponse(response);
				break;
			case "resizeWindow":
				var w = parseInt(params["width"]);
				var h = parseInt(params["height"]);
				var ifrm = document.getElementById("iframePayment");
				ifrm.style.width = w.toString() + "px";
				ifrm.style.height = h.toString() + "px";
				centerPopup(w + 12);
				break;
			}
		};

		function centerPopup(width) {
			var p = document.getElementById("paymentForm_CH");
			var d = document.getElementById("divPaymentPopup");
			var ppos = getTopPosition(p);
			var top = ppos - Math.floor(d.clientHeight / 2);
			d.style.top = top.toString() + "px";
			d.style.left = "50%";
			if (!width)
				width = d.clientWidth;
			var left = -Math.floor(width / 2);
			d.style.width = width.toString() + "px";
			d.style.marginLeft = left.toString() + "px";
			d.style.zIndex = "2";
			if (d.offsetLeft < 16) {
				d.style.left = "16px";
				d.style.marginLeft = "0px";
				}
			if (d.offsetTop < 24) {
				d.style.top = "24px";
				d.style.marginTop = "0px";
				}
			}

		function parseQueryString(str) {
				var vars = [];
				var arr = str.split('&');
				var pair;
				for (var i = 0; i < arr.length; i++) {
					pair = arr[i].split('=');
					vars.push(pair[0]);
					if (pair[0] === "response") {
						let jresp = str.indexOf(pair[1]);
						if (jresp >= 0)
							pair[1] = str.substring(jresp);
					}
					vars[pair[0]] = unescape(pair[1]);
				}
				return vars;
			}

		function getTopPosition(el) {
			var yPos = 0;

			while (el) {
			  if (el.tagName == "BODY") {
				// Ignore scroll position of page
				yPos += (el.offsetTop + el.clientTop);
			  } else {
				// for non-BODY elements
				yPos += (el.offsetTop - el.scrollTop + el.clientTop);
			  }

			  el = el.offsetParent;
			}
			return yPos;
		}

	}());



// WEBPACK FOOTER //
// ./src/components/paypopup.js